// ** Auth Endpoints

const {
  REACT_APP_API_URL,
  REACT_APP_LOGIN_URL,
  REACT_APP_REFRESH_TOKEN_URL
} = process.env

export default {
  // loginEndpoint: 'jwt/login',
  loginEndpoint: REACT_APP_API_URL + REACT_APP_LOGIN_URL,
  registerEndpoint: '/jwt/register',
  refreshEndpoint: REACT_APP_API_URL + REACT_APP_REFRESH_TOKEN_URL,
  logoutEndpoint: '/jwt/logout',

  // ** This will be prefixed in authorization header with token
  // ? e.g. Authorization: Bearer <token>
  tokenType: 'Bearer',

  // ** Value of this property will be used as key to store JWT token in storage
  storageTokenKeyName: 'accessToken',
  storageRefreshTokenKeyName: 'refreshToken'
}
